"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitModule = void 0;
const base_1 = require("./base");
class SubmitModule extends base_1.SurveyModule {
    constructor(_a = {}) {
        var { label = { en: "" }, noBorder = true, complete = false, href } = _a, rest = __rest(_a, ["label", "noBorder", "complete", "href"]);
        super(rest);
        this._type = "submit";
        this.href = href;
        this.label = label;
        this.noBorder = noBorder;
        this.complete = complete;
    }
    validate() {
        return true;
    }
    toBuilderConfig() {
        if (this.validate()) {
            const builderConfigModule = {
                id: this.id,
                style: this.style,
                complete: this.complete,
                label: this.label,
                type: this.type,
            };
            if (this.tag) {
                builderConfigModule.tag = this.tag;
            }
            if (this.href) {
                builderConfigModule.href = this.href;
            }
            return builderConfigModule;
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    toSurveyConfig() {
        var _a;
        const surveyConfigModule = {
            id: this.id,
            style: this.style,
            children: this.label[this.languageCode],
            complete: this.complete,
            type: this.type,
        };
        // needed to ensure empty strings can be passed for the use of featuredCtas in the preview
        if (typeof ((_a = this.href) === null || _a === void 0 ? void 0 : _a[this.languageCode]) === "string") {
            surveyConfigModule.href = this.href[this.languageCode];
        }
        return surveyConfigModule;
    }
    editProps() {
        return undefined;
    }
}
exports.SubmitModule = SubmitModule;
//# sourceMappingURL=Submit.js.map